import { render, staticRenderFns } from "./WorkOrderCompletionStatusTag.vue?vue&type=template&id=25f856d0&scoped=true&"
import script from "./WorkOrderCompletionStatusTag.vue?vue&type=script&lang=ts&"
export * from "./WorkOrderCompletionStatusTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f856d0",
  null
  
)

export default component.exports